/** Fixed choice lists. Typing free text into these fields produced junk data
    that later has to be cleaned up before it reaches a printed form. */

export const TRANSMISSIONS = ["Automatic", "Manual"] as const;

export const DRIVETRAINS = ["FWD", "RWD", "AWD", "4WD"] as const;

export const FUEL_TYPES = ["Gasoline", "Diesel", "Hybrid", "Electric"] as const;

export const BODY_TYPES = [
  "Sedan", "Coupe", "Hatchback", "Convertible", "Wagon",
  "SUV", "Crossover", "Minivan", "Van", "Pickup", "Truck",
] as const;

export const DOOR_COUNTS = ["2", "3", "4", "5"] as const;

export const COLORS = [
  "Black", "White", "Silver", "Gray", "Red", "Blue", "Green",
  "Brown", "Beige", "Gold", "Orange", "Yellow", "Burgundy", "Purple",
] as const;

export const SOURCE_TYPES = ["Auction", "Trade-In", "Private Seller"] as const;

export const AUCTION_HOUSES = [
  "Manheim", "OpenLane", "ACV", "CarMax", "Copart", "IAAI",
] as const;

export const TITLE_STATUSES = [
  { value: "not_received", label: "Not received" },
  { value: "in_hand", label: "In hand" },
  { value: "sent_to_state", label: "Sent to state" },
  { value: "with_lienholder", label: "With lienholder" },
] as const;

/** vPIC returns its own vocabulary. Map it onto ours so decoded values land
    on a real option instead of silently failing to match. */
export function normaliseTransmission(v: string): string {
  const s = v.toLowerCase();
  if (!s) return "";
  if (s.includes("manual")) return "Manual";
  if (s.includes("automat") || s.includes("cvt") || s.includes("dual")) return "Automatic";
  return "";
}

export function normaliseDrivetrain(v: string): string {
  const s = v.toUpperCase();
  if (s.includes("FWD") || s.includes("FRONT")) return "FWD";
  if (s.includes("RWD") || s.includes("REAR")) return "RWD";
  if (s.includes("AWD") || s.includes("ALL")) return "AWD";
  if (s.includes("4WD") || s.includes("4X4") || s.includes("FOUR")) return "4WD";
  return "";
}

export function normaliseFuel(v: string): string {
  const s = v.toLowerCase();
  if (s.includes("diesel")) return "Diesel";
  if (s.includes("electric") && !s.includes("hybrid")) return "Electric";
  if (s.includes("hybrid")) return "Hybrid";
  if (s.includes("gas") || s.includes("petrol") || s.includes("flex")) return "Gasoline";
  return "";
}

export function normaliseBody(v: string): string {
  const s = v.toLowerCase();
  if (!s) return "";
  if (s.includes("sedan") || s.includes("saloon")) return "Sedan";
  if (s.includes("coupe")) return "Coupe";
  if (s.includes("hatch")) return "Hatchback";
  if (s.includes("convertible") || s.includes("cabriolet")) return "Convertible";
  if (s.includes("wagon")) return "Wagon";
  if (s.includes("pickup")) return "Pickup";
  if (s.includes("minivan")) return "Minivan";
  if (s.includes("van")) return "Van";
  if (s.includes("truck")) return "Truck";
  if (s.includes("crossover")) return "Crossover";
  if (s.includes("sport utility") || s.includes("suv") || s.includes("mpv")) return "SUV";
  return "";
}
